var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "brick-settings-base",
        {
          attrs: {
            title: _vm.resource(
              "JourneyComposer_BrickSettingsTouchpoint_Title"
            ),
            canWrite: _vm.canWrite,
            prompt: {
              title: _vm.resource(
                "JourneyBuilder_TouchpointSettings_Delete_Title"
              ),
              body: _vm.resource(
                "JourneyBuilder_TouchpointSettings_Delete_Body"
              )
            }
          },
          on: {
            save: _vm.save,
            delete: function($event) {
              return _vm.$emit("delete")
            },
            hidden: function($event) {
              return _vm.$emit("hide")
            }
          },
          model: {
            value: _vm.newName,
            callback: function($$v) {
              _vm.newName = $$v
            },
            expression: "newName"
          }
        },
        [
          _c("settings-item", {
            attrs: { icon: "fas fa-hand-point-right" },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("label", { attrs: { for: "type" } }, [
                        _vm._v(_vm._s(_vm.fieldName))
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-select",
                        {
                          staticClass: "form-control",
                          attrs: {
                            id: "type",
                            label: "name",
                            options: _vm.touchPointTypes,
                            disabled: !_vm.canWrite,
                            clearable: false,
                            searchable: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.selectedTouchPointType,
                            callback: function($$v) {
                              _vm.selectedTouchPointType = $$v
                            },
                            expression: "selectedTouchPointType"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "no-options" },
                            slot: "no-options"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1351045693
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }